var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTpWorkIcon02(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.54,
    d: "M24.5193 9.44219C24.9974 8.76468 26.0022 8.76468 26.4803 9.44219L45.4736 36.3582C46.0345 37.1532 45.466 38.2501 44.4931 38.2501H6.50648C5.53358 38.2501 4.96508 37.1531 5.52601 36.3582L24.5193 9.44219Z",
    fill: "#FF8139"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.75 35.5726V9.92385C46.75 7.37385 44.6675 5.4826 42.1387 5.6951H42.0113C37.5488 6.0776 30.77 8.35135 26.9875 10.7313L26.6262 10.9651C26.01 11.3476 24.99 11.3476 24.3738 10.9651L23.8425 10.6463C20.06 8.2876 13.3025 6.0351 8.84 5.67385C6.31125 5.46135 4.25 7.37385 4.25 9.9026V35.5726C4.25 37.6126 5.9075 39.5251 7.9475 39.7801L8.56375 39.8651C13.175 40.4813 20.2938 42.8188 24.3738 45.0501L24.4588 45.0926C25.0325 45.4113 25.9463 45.4113 26.4988 45.0926C30.5788 42.8401 37.7188 40.4813 42.3513 39.8651L43.0525 39.7801C45.0925 39.5251 46.75 37.6126 46.75 35.5726Z",
    stroke: "#0C111D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 11.6663V43.5413",
    stroke: "#0C111D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4688 18.0413H11.6875",
    stroke: "#0C111D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0625 24.4163H11.6875",
    stroke: "#0C111D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTpWorkIcon02);
export default __webpack_public_path__ + "static/media/tp-work-icon02.ace4a375d0c41e0ef10057dda1fdb957.svg";
export { ForwardRef as ReactComponent };